module.exports = __webpack_public_path__ + "img/step55_a_route_cables.c25d09fb.png";